import type { TFunction } from 'i18next'
import type {
  ParentT,
  PopoverProperty,
} from '@/components/common/propertyPopoverOverlay/Property.tsx'

/**
 * Stored next to user IRIs in the `recipients` filter, e.g.
 * `recipients=["UNASSIGNED","/users/12"]`, and sent to the API as
 * `recipient[]=UNASSIGNED`. It selects issues WITHOUT a recipient; together
 * with users it is OR-ed, so the result is the union.
 *
 * Mirrors IssueRecipientFilter::UNASSIGNED on the backend, which is the only
 * place that turns it into SQL; keep the two spellings identical.
 */
export const UNASSIGNED_RECIPIENT = 'UNASSIGNED'

/** API Platform omits null values, so an unassigned issue may lack the key entirely. */
export function isUnassignedRecipient(recipient: string | null | undefined): boolean {
  return recipient === null || recipient === undefined || recipient === ''
}

/**
 * The "No recipient" option. Built from `t` at call time rather than at module
 * scope, so the label follows the active language.
 */
export function createUnassignedRecipientProperty(t: TFunction, parent?: ParentT): PopoverProperty {
  const property: PopoverProperty = {
    label: t('project.issues.noRecipient'),
    value: UNASSIGNED_RECIPIENT,
  }
  if (parent) property.parent = parent

  return property
}
